// Flash Cards — Fill-in comparison.
// R11 (2026-10-24, SUPERSEDES the earlier exact-case-only requirement): the ONLY
// configurable difference is case sensitivity, via the `caseSensitive` option
// (default FALSE → case-INSENSITIVE comparison). Everything else is still exact:
// NO trim, NO punctuation removal, NO accent folding, NO whitespace collapsing,
// NO Unicode normalization. Case folding (when insensitive) uses
// String.prototype.toLowerCase() only — it does not strip diacritics or alter
// whitespace/punctuation.
//
// This module is Flash-Cards-local by design. Do not route Fill-in comparison
// through any shared/normalizing helper.

/**
 * @param {string} rawInput        the learner's raw input string, untouched
 * @param {string} storedExpected  the authored expected answer, untouched
 * @param {boolean} [caseSensitive=false] when true, compare code-unit for
 *   code-unit; when false (default), compare case-insensitively (toLowerCase)
 *   with no other change.
 * @returns {boolean} true when the two strings match under the chosen case mode
 */
export const isExactMatch = (rawInput, storedExpected, caseSensitive = false) => {
  if (typeof rawInput !== 'string' || typeof storedExpected !== 'string') {
    return false;
  }
  if (caseSensitive) {
    return rawInput === storedExpected;
  }
  // Case-insensitive default: fold case only — whitespace, punctuation and
  // diacritics are preserved (no trim, no normalize).
  return rawInput.toLowerCase() === storedExpected.toLowerCase();
};

/**
 * A blank submission (empty string) is not a valid answer attempt (D3).
 * Whitespace-only is NOT blank — only the empty string is, because we must not
 * trim. A single space is a real (wrong) answer, not a blank.
 */
export const isBlankSubmission = (rawInput) =>
  typeof rawInput !== 'string' || rawInput.length === 0;

export default isExactMatch;
